import { Typography } from '@mui/material';
import { useProfileStyles } from '../styles';

export const PendingTypography: React.VFC = () => {
  const { classes } = useProfileStyles();

  return <Typography className={classes.pendingTypography}>Pending</Typography>;
};
